module.exports = ".addInventoryLabel {\r\n\twidth:170px;\r\n}\r\n\r\n@media all and (min-width: 768px) {\r\n  tr  {\r\n    td {\r\n      vertical-align: middle !important;\r\n    }\r\n    span {\r\n      &:not([class]) {\r\n        padding: 1rem 1rem;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n.input-res\r\n{\r\n     width: 100%;\r\n     max-width: 500px;\r\n     -webkit-box-sizing: border-box;\r\n             box-sizing: border-box;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/inventory-manager/add-multiple-inventory/add-multiple-inventory.component.css
// module id = ./src/app/inventory-manager/add-multiple-inventory/add-multiple-inventory.component.css
// module chunks = main